import ListingPreviewCell from './ListingPreviewCell'

export default ListingPreviewCell
